mutation CreateVideoFileUpload($input: CreateVideoFileUploadInput!) {
  createVideoFileUpload(input: $input) {
    videoFile {
      id
      status
      fileName
    }
    uploadUrl
    headers {
      name
      value
    }
  }
}
